import { DownloadOption } from "@/entry/server/movie";

export function ConvertDownloadTypeToTitle(type: string): string {
    switch (type) {
        case 'farsi_dubbed':
            return 'دوبله فارسی';
        case 'with_subtitle':
            return 'زیرنویس فارسی چسبیده';
        case 'without_subtitle':
            return 'بدون زیرنویس';
        default:
            return type;
    }
}

export function FormatSize(size: number): string {
    if (size == 0) return 'نامشخص';
    if (size < 1024) return 'B ' + size;
    if (size < 1024 * 1024) return 'KB ' + (size / 1024).toFixed(2);
    if (size < 1024 * 1024 * 1024) return 'MB ' + (size / 1024 / 1024).toFixed(2);
    return 'GB ' + (size / 1024 / 1024 / 1024).toFixed(2);
}

const DOWNLOAD_TYPE_PRIORITY = ["farsi_dubbed", "with_subtitle", "without_subtitle"] as const;

function parseQualityCode(qualityCode: string): number {
    return parseInt(qualityCode.split("p")[0], 10) || 0;
}

function pickPreferredTypeOptions(options: DownloadOption[]): DownloadOption[] {
    for (const type of DOWNLOAD_TYPE_PRIORITY) {
        const typed = options.filter((option) => option.type === type);
        if (typed.length) return typed;
    }
    return options;
}

function pickBestQualityOption(options: DownloadOption[]): DownloadOption {
    return [...options].sort((a, b) => parseQualityCode(b.quality_code) - parseQualityCode(a.quality_code))[0];
}

export function getDefaultPlayerUrl(
    id: number,
    isSeries: boolean,
    options: DownloadOption[]
): string | null {
    if (!options.length) return null;

    const preferredOptions = pickPreferredTypeOptions(options);

    if (isSeries) {
        const minSeason = Math.min(...preferredOptions.map((option) => option.season));
        const seasonOptions = preferredOptions.filter((option) => option.season === minSeason);
        const minEpisode = Math.min(...seasonOptions.map((option) => option.episode));
        const episodeOptions = seasonOptions.filter((option) => option.episode === minEpisode);
        const best = pickBestQualityOption(episodeOptions);

        return `/player/${id}?season=${best.season}&episode=${best.episode}&quality=${best.quality}&type=${best.type}`;
    }

    const best = pickBestQualityOption(preferredOptions);
    return `/player/${id}?quality=${best.quality}&type=${best.type}`;
}